export const PLAYER_REPORTABLE_EVENTS = {
  REBUFFER_START: 'rebufferstart',
  ERROR: 'error',
  RENDITION_CHANGE: 'renditionchange',
  BUFFER_STALLED: 'bufferStalled',
  BUFFER_DEPLETED: 'bufferDepleted',
  BUFFER_RECOVERED: 'bufferRecovered',
}

export const PLAYER_ERROR_CODES = {
  NETWORK: '100',
  MEDIA: '102',
  GENERIC_ERROR: '103',
  GEO: 'geo',
  UNKNOWN_ERROR: 'unknown',
}
